import { ThemeProvider,CssBaseline,Box } from "@mui/material";
import { BrowserRouter,Routes,Route,useLocation,Navigate } from "react-router-dom";
import { useEffect,useRef,useState } from "react";

import Navbar from "./components/Navbar";
import Scroll from "./components/Scroll";
import Footer from "./components/Footer";

import Home from "./pages/Home";
import Calendar from "./pages/Calendar";
import Gallery from "./pages/Gallery";
import LiveMatchPage from "./pages/LiveMatchPage";
import Rules from "./pages/Rules";

import Login from "./login/Login";
import UpdatePassword from "./login/UpdatePassword";
import AdminDashboard from "./login/Admin/AdminDashboard";
import DelegateDashboard from "./login/Delegado/DelegateDashboard";
import ProtectedRoute from "./login/ProtectedRoute";

import theme from "./Theme";

function Layout(){
  const location=useLocation();
  const isPrivateRoute=location.pathname.startsWith("/admin")||location.pathname.startsWith("/delegado")||location.pathname==="/actualizar-clave";
  const lastScroll=useRef(0);
  const [showNavbar,setShowNavbar]=useState(true);

  useEffect(()=>{
    window.scrollTo(0,0);
  },[location.pathname]);

  useEffect(()=>{
    if(isPrivateRoute) return;

    const handleScroll=()=>{
      const current=window.scrollY;

      if(current<80){
        setShowNavbar(true);
      }else if(current>lastScroll.current){
        setShowNavbar(false);
      }else{
        setShowNavbar(true);
      }

      lastScroll.current=current;
    };

    window.addEventListener("scroll",handleScroll,{passive:true});
    return ()=>window.removeEventListener("scroll",handleScroll);
  },[isPrivateRoute]);

  return (
    <Box sx={{display:"flex",flexDirection:"column",minHeight:"100vh",background:"#FFFFFF"}}>
      {!isPrivateRoute&&(
        <Box sx={{position:"sticky",top:0,zIndex:1200,transition:"transform .28s ease, opacity .28s ease",transform:showNavbar?"translateY(0)":"translateY(-110%)",opacity:showNavbar?1:0}}>
          <Navbar />
        </Box>
      )}

      {!isPrivateRoute&&<Scroll />}

      <Box sx={{flex:1}}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/calendario-de-partidos" element={<Calendar />} />
          <Route path="/galeria" element={<Gallery />} />
          <Route path="/partido/:slug" element={<LiveMatchPage />} />
          <Route path="/reglamento" element={<Rules />} />
          <Route path="/admin-login" element={<Login />} />
          <Route path="/actualizar-clave" element={<ProtectedRoute allowedRoles={["SUPERADMIN","ADMIN","DELEGADO"]}><UpdatePassword /></ProtectedRoute>} />
          <Route path="/admin/*" element={<ProtectedRoute allowedRoles={["SUPERADMIN","ADMIN"]}><AdminDashboard /></ProtectedRoute>} />
          <Route path="/delegado/*" element={<ProtectedRoute allowedRoles={["DELEGADO"]}><DelegateDashboard /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Box>

      {!isPrivateRoute&&<Footer />}
    </Box>
  );
}

function App(){
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;